import { SPGameState } from "../enum/GameState";
import { RandomExpSound, SoundType } from "../enum/sounds";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import SoundManager from "./SoundManager";
import SPGameManager from "./SPGameManager";
import SPPlayer from "./SPPlayer";

export default class ExpOrb extends MonoBehavior {
    amount = 1;
    velocity = Vector2.zero;
    speed = 1;

    Update(): void {
        if (!SPGameManager.Singleton.isInGame) return;

        const player = this.engine.GetGameObjectsBehaviors<SPPlayer>(SPPlayer)[0];

        if (!player) return;

        const vec = player.transform.position.sub(this.transform.position).normalized.scale(this.speed); 
        this.velocity = vec;
        this.speed += 64 * Time.deltaTime;

        if (Vector2.distance(this.transform.position, player.transform.position) < player.size + 2) {
            player.AddExp(this.amount);
            this.engine.RemoveGameObject(this.gameObject);
            SoundManager.Singleton.PlaySound(RandomExpSound(), SoundType.SFX);
        }

        this.transform.position = this.transform.position.add(this.velocity.scale(Time.deltaTime));
    }

    Draw(): void {
        this.ctx.strokeStyle = '#ffff55';
        this.ctx.lineWidth = 1;
        this.engine.StrokeCircle(this.transform.position, 2);
    }

}